// extracted by mini-css-extract-plugin
export var deliveryRow = "_ny-a";
export var fixedHeight = "_ny-4";
export var freightLogo = "_ny-9";
export var fullWidth = "_ny-3";
export var priceColumn = "_ny-5";
export var radioSelected = "_ny-7";
export var radioUnselected = "_ny-6";
export var selectedOption = "_ny-2";
export var selectedOptionContainer = "_ny-1";
export var selection = "_ny-0";
export var tallSkeletonText = "_ny-8";